var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5629 17.9997H3.4381C2.73211 17.9997 2.21012 17.3027 2.47711 16.6617C3.71309 13.6977 6.61704 11.9998 9.99998 11.9998C13.3839 11.9998 16.2879 13.6977 17.5239 16.6617C17.7908 17.3027 17.2689 17.9997 16.5629 17.9997ZM5.91705 5.99988C5.91705 3.79392 7.74902 1.99995 9.99998 1.99995C12.2519 1.99995 14.0829 3.79392 14.0829 5.99988C14.0829 8.20584 12.2519 9.99981 9.99998 9.99981C7.74902 9.99981 5.91705 8.20584 5.91705 5.99988ZM19.9558 17.6357C19.2138 14.2767 16.8919 11.7978 13.8369 10.6728C15.4559 9.3958 16.3999 7.3308 16.0529 5.06984C15.6509 2.44689 13.4229 0.347971 10.735 0.0419761C7.02304 -0.381017 3.87509 2.44894 3.87509 5.99988C3.87509 7.88985 4.76908 9.57379 6.16405 10.6728C3.10711 11.7978 0.787143 14.2767 0.0441561 17.6357C-0.225839 18.8566 0.779145 19.9996 2.05412 19.9996H17.9458C19.2218 19.9996 20.2258 18.8566 19.9558 17.6357Z",
    fill: "#B2022F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconInfo);
export default __webpack_public_path__ + "static/media/user_icon_info.c03ea95da9a09b17077b19473e50a569.svg";
export { ForwardRef as ReactComponent };